var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products-group"},_vm._l((_vm.product),function(item){return _c('products',{key:item.name,attrs:{"product":item,"id":_vm.groupname}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }